import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi";
import type { LeaderCriteriaResponse } from "~pages/LeaderCriteria/types/leaderCriteria.ts";
import { removeEmptyFields } from "~utils/removeEmptyFields.ts";
import { transformListResponse } from "~utils/transformListResponse.ts";

type Props = {
  customParams: Record<string, string>;
};

export const useFetchLeaderCriteriaList = ({ customParams }: Props) => {
  const request = useApi();
  const { organizationId, sport } = useParams();

  const params = new URLSearchParams(removeEmptyFields(customParams) as Record<string, string>);

  return useQuery({
    queryKey: ["leaderCriteria", sport, organizationId, customParams],
    queryFn: () =>
      request<LeaderCriteriaResponse>(`${sport}/o/${organizationId}/statistics/leaders/criteria?${params.toString()}`).then((response) =>
        transformListResponse(response),
      ),
  });
};
